// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import CaboVerde from '../_raw/flag/icon_flag_cabo_verde.png';

export default () => <img src={CaboVerde} alt="CaboVerde" />;
